import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["validation-schema"]
const _hoisted_2 = { class: "relative mt-6" }
const _hoisted_3 = { class: "flex items-center relative" }
const _hoisted_4 = { class: "relative" }
const _hoisted_5 = { class: "flex items-center justify-center" }
const _hoisted_6 = { class: "flex items-center justify-center w-[60px] h-[60px] rounded-full bg-white" }
const _hoisted_7 = { class: "flex items-center justify-center mb-2" }
const _hoisted_8 = { class: "flex items-center justify-center" }
const _hoisted_9 = { class: "text-m2" }
const _hoisted_10 = ["id"]
const _hoisted_11 = { class: "flex items-center justify-center mb-2 py-6" }
const _hoisted_12 = { class: "flex items-center justify-center w-full h-full bg-black/50" }
const _hoisted_13 = { class: "uppercase font-sourcesanspro-semibold text-center" }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = {
  key: 0,
  class: "flex items-center justify-center"
}
const _hoisted_16 = { class: "flex px-2 py-2 bg-black rounded-full font-sourcesanspro-semibolditalic text-xs2 text-white/70" }
const _hoisted_17 = { class: "flex mt-6 items-center justify-center mb-1" }
const _hoisted_18 = { class: "flex flex-col items-center justify-center font-sourcesanspro-semibold text-dark-blue" }
const _hoisted_19 = { class: "px-1 text-l2 text-center" }
const _hoisted_20 = { class: "text-dark-blue/70" }
const _hoisted_21 = {
  key: 0,
  class: "flex flex-col items-center justify-center mb-2"
}
const _hoisted_22 = { class: "font-sourcesanspro-semibold text-xs2 text-dark-blue/70" }
const _hoisted_23 = { class: "flex flex-col items-center justify-center mb-2" }
const _hoisted_24 = { class: "font-sourcesanspro-semibold text-base2 text-white text-center break-words px-2" }
const _hoisted_25 = {
  key: 1,
  class: "flex flex-col items-center justify-center mb-2"
}
const _hoisted_26 = { class: "font-sourcesanspro-semibold text-xs2 text-dark-blue/70" }
const _hoisted_27 = {
  key: 2,
  class: "flex flex-col items-center justify-center mb-2"
}
const _hoisted_28 = { class: "font-sourcesanspro-semibold text-xs2 text-dark-blue/70" }
const _hoisted_29 = {
  key: 3,
  class: "flex flex-col items-center justify-center mb-2"
}
const _hoisted_30 = {
  key: 0,
  class: "font-sourcesanspro-semibold text-sm text-dark-blue"
}
const _hoisted_31 = {
  key: 1,
  class: "font-sourcesanspro-semibold text-sm text-dark-blue/70"
}
const _hoisted_32 = {
  key: 4,
  class: "flex items-center justify-center mb-4"
}
const _hoisted_33 = { class: "text-base" }
const _hoisted_34 = { class: "mb-2" }
const _hoisted_35 = { class: "font-sourcesanspro-semibold text-xs2 text-dark-blue leading-normal" }
const _hoisted_36 = { class: "flex items-center justify-between mb-1" }
const _hoisted_37 = { class: "flex flex-col" }
const _hoisted_38 = { class: "font-sourcesanspro-bold text-base" }
const _hoisted_39 = { class: "font-sourcesanspro-regular text-base2" }
const _hoisted_40 = { class: "flex items-center justify-between mb-1" }
const _hoisted_41 = { class: "flex flex-col" }
const _hoisted_42 = { class: "font-sourcesanspro-bold text-base" }
const _hoisted_43 = { class: "font-sourcesanspro-regular text-base2" }
const _hoisted_44 = {
  key: 0,
  class: "flex items-center justify-between mb-1"
}
const _hoisted_45 = { class: "flex flex-col max-w-[85%]" }
const _hoisted_46 = { class: "font-sourcesanspro-bold text-base" }
const _hoisted_47 = { class: "font-sourcesanspro-regular text-base2 text-dark-blue/70" }
const _hoisted_48 = {
  key: 1,
  class: "flex items-center justify-between mb-1"
}
const _hoisted_49 = { class: "flex flex-col" }
const _hoisted_50 = { class: "font-sourcesanspro-bold text-base" }
const _hoisted_51 = { class: "font-sourcesanspro-regular text-base2" }

import { ref, watch, computed } from 'vue';
import router from '@/router';
import { IonButton, IonIcon, IonInput } from '@ionic/vue';
import { calendarClearOutline, closeOutline, createOutline, linkOutline, locationOutline, timeOutline, downloadOutline, informationCircleOutline } from 'ionicons/icons';
import * as Yup from 'yup';
import QrcodeVue from 'qrcode.vue';
import { DateTime } from 'luxon';
import { useI18n } from 'vue-i18n';

import ModalOne from '@/shared/components/ui/ModalOne.vue';
import TextInput from '@/shared/components/sign-up-forms/TextInput.vue';
import useCustomForm from '@/shared/composables/useCustomForm';
import useEvents from '@/modules/events/composables/useEvents';
import { Event, EventTicket } from '@/shared/interfaces/event';

// Props

export default /*@__PURE__*/_defineComponent({
  __name: 'TicketDetailItem',
  props: {
	email: { type: String, required: true },
	eventAllowEditTickets: { type: Boolean, required: true },
	eventDate: { type: String, required: true },
	eventId: { type: Number, required: true },
	eventName: { type: String, required: true },
	eventTickets: { type: Array as () => EventTicket[], required: false },
	hideQrCode: { type: Boolean, default: false },
	idx: { type: Number, required: true },
	name: { type: String, required: true },
	qrCode: { type: String, required: true },
	ticket: { type: Object as () => EventTicket, required: true },
	ticketDisabledEdit: { type: Boolean, required: true },
	ticketId: { type: String, required: true },
	ticketTypeColor: { type: String },
	ticketTypeName: { type: String },
	ticketTypeDescription: { type: String, default: '' },
	valueOnly: { type: Boolean, required: true, default: false },
	venue: { type: String, required: true },
	walletLinked: { type: Number as () => number | null | undefined },
},
  emits: ['onRefetchTickets'],
  setup(__props, { emit: __emit }) {

const props = __props;

// Init
const hideQrCode = ref(props.hideQrCode);
const { t, locale } = useI18n();
const emit = __emit;
const isModalOpen = ref(false);
const qrCodeSizes = [150, 230, 80];
const qrCodeSize = ref(qrCodeSizes[0]); // Default size
const currentSizeIndex = ref(0);

const showHideModal = (openState: boolean) => {
	isModalOpen.value = openState;
};

const cycleQrCodeSize = () => {
	currentSizeIndex.value = (currentSizeIndex.value + 1) % qrCodeSizes.length;
	qrCodeSize.value = qrCodeSizes[currentSizeIndex.value];
};
const { downloadTicket } = useEvents();
const downloadingTicket = ref({ ticketIndex: -1, isDownloading: false });

// Using yup to generate a validation schema
const schema = Yup.object().shape({
	name: Yup.string().required(),
	email: Yup.string().required(),
});

// useCustomForm
const { isFormValid, isSuccess, onSubmit, onInputChange } = useCustomForm(schema, `/events/edit-ticket/${props.ticketId}`, 'post', 'ticket.saved', 'ticket.saving_error', 5000);

// Refetch ticket
watch(isSuccess, () => {
	if (isSuccess) {
		emit('onRefetchTickets');
		showHideModal(false);
		isSuccess.value = false;
	}
});

const showQrCode = () => {
	hideQrCode.value = false;
};

// Close modal and go to page
const closeModalAndGo = () => {
	showHideModal(false);
	router.push(`/friends/select?type=ticket&id=${props.ticketId}&eventId=${props.eventId}`);
};

// Start downloading ticket
const startDownloadingTicket = async (event: Event, ticket: EventTicket, idx: number) => {
	downloadingTicket.value = { ticketIndex: idx, isDownloading: true };
	await downloadTicket(event, ticket);
	downloadingTicket.value.isDownloading = false;
};

// Queue ticket computed properties
const isQueueTicket = computed(() => {
	return !!props.ticket.queue_activity_id;
});

const activityName = computed(() => {
	if (!isQueueTicket.value) return '';
	return props.ticket.queue_activity?.name || `Activity ${props.ticket.queue_activity_id}`;
});

const displayTicketType = computed(() => {
	return props.ticket.combo_ticket_type?.name || props.ticket.ticket_type?.name || props.ticketTypeName || '';
});

const formattedTimeslot = computed(() => {
	if (!isQueueTicket.value) return '';
	if (!props.ticket.queue_slot?.booked_time_slot) return null;

	const timeslot = props.ticket.queue_slot.booked_time_slot;
	const bookedDate = props.ticket.queue_slot?.booked_date;
	const activity = props.ticket.queue_activity || props.ticket.queue_slot?.queue_activity;

	// Format the date if available
	let dateStr = '';
	if (bookedDate) {
		try {
			const date = new Date(bookedDate);
			const localeMap: Record<string, string> = {
				'en': 'en-US',
				'es': 'es-ES',
				'fr': 'fr-FR',
				'pt': 'pt-PT',
				'nl': 'nl-NL',
			};
			const intlLocale = localeMap[locale.value] || locale.value || 'en-US';

			dateStr = date.toLocaleDateString(intlLocale, {
				month: 'short',
				day: 'numeric',
				year: 'numeric',
			});
		} catch {
			dateStr = bookedDate;
		}
	}

	// Check if timeslot is a UTC datetime string (e.g., "2025-10-31T09:00:00.000000Z")
	const isUtcDateTime = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/.test(timeslot.trim());

	let timeStr = '';

	if (isUtcDateTime) {
		// Parse UTC datetime and convert to local time
		try {
			const utcDate = new Date(timeslot);
			if (!isNaN(utcDate.getTime())) {
				// Extract local time
				const localHours = utcDate.getHours().toString().padStart(2, '0');
				const localMinutes = utcDate.getMinutes().toString().padStart(2, '0');
				const startTime = `${localHours}:${localMinutes}`;

				// Calculate end time from cycle duration
				if (activity && activity.cycle_duration_minutes) {
					const endDate = new Date(utcDate.getTime() + activity.cycle_duration_minutes * 60000);
					const endHours = endDate.getHours().toString().padStart(2, '0');
					const endMinutes = endDate.getMinutes().toString().padStart(2, '0');
					const endTime = `${endHours}:${endMinutes}`;

					timeStr = `${startTime} - ${endTime}`;
				} else {
					timeStr = startTime;
				}
			}
		} catch (error) {
			console.error('Error parsing UTC datetime:', error);
		}
	} else {
		// If timeslot is a simple time string like "10:00", use it directly
		const simpleTimePattern = /^(\d{1,2}:\d{2})(?::\d{2})?$/;
		const simpleMatch = timeslot.trim().match(simpleTimePattern);
		if (simpleMatch) {
			const startTime = simpleMatch[1]; // Already in HH:MM format

			// Calculate end time from cycle duration
			if (activity && activity.cycle_duration_minutes) {
				const [hours, minutes] = startTime.split(':').map(Number);
				const startDate = new Date();
				startDate.setHours(hours, minutes, 0, 0);

				// Add cycle duration
				const endDate = new Date(startDate.getTime() + activity.cycle_duration_minutes * 60000);

				const endHours = endDate.getHours().toString().padStart(2, '0');
				const endMinutes = endDate.getMinutes().toString().padStart(2, '0');
				const endTime = `${endHours}:${endMinutes}`;

				timeStr = `${startTime} - ${endTime}`;
			} else {
				timeStr = startTime;
			}
		} else {
			// If timeslot contains a date-time format, extract the time portion
			const allTimeMatches = timeslot.match(/(\d{1,2}:\d{2})(?::\d{2})?/g);

			if (allTimeMatches && allTimeMatches.length >= 2) {
				// Already has both times (e.g., "10:00-11:00" or date-time format)
				const startTime = allTimeMatches[allTimeMatches.length - 2].substring(0, 5); // Keep only HH:MM
				const endTime = allTimeMatches[allTimeMatches.length - 1].substring(0, 5); // Keep only HH:MM
				timeStr = `${startTime} - ${endTime}`;
			} else if (allTimeMatches && allTimeMatches.length === 1) {
				// Single time found in date-time string
				const startTime = allTimeMatches[0].substring(0, 5); // Keep only HH:MM

				// Calculate end time from cycle duration
				if (activity && activity.cycle_duration_minutes) {
					const [hours, minutes] = startTime.split(':').map(Number);
					const startDate = new Date();
					startDate.setHours(hours, minutes, 0, 0);

					// Add cycle duration
					const endDate = new Date(startDate.getTime() + activity.cycle_duration_minutes * 60000);

					const endHours = endDate.getHours().toString().padStart(2, '0');
					const endMinutes = endDate.getMinutes().toString().padStart(2, '0');
					const endTime = `${endHours}:${endMinutes}`;

					timeStr = `${startTime} - ${endTime}`;
				} else {
					timeStr = startTime;
				}
			} else {
				// Fallback: return as is
				timeStr = timeslot;
			}
		}
	}

	// Combine date and time if both are available
	if (dateStr && timeStr) {
		return `${dateStr} • ${timeStr}`;
	} else if (timeStr) {
		return timeStr;
	}

	return timeslot;
});

const isUnbooked = computed(() => {
	return isQueueTicket.value && !props.ticket.queue_slot;
});

const queueTypeDisplay = computed(() => {
	if (!isQueueTicket.value) return '';
	const queueType = props.ticket.queue_slot?.queue_type || props.ticket.queue_type;
	if (queueType === 'fastlane') {
		return t('queue.priority_pass');
	}
	return t('queue.regular_pass');
});

const handleBookNow = () => {
	if (!isUnbooked.value || !props.ticket.queue_activity_id) return;

	// Store event ticket ID(s) in sessionStorage (similar to QueueTicketsBuyPage)
	const ticketIds = [props.ticket.id];
	sessionStorage.setItem('booking_event_ticket_ids', JSON.stringify(ticketIds));

	// Navigate to my-queues page
	router.push('/my-queues');
};

return (_ctx: any,_cache: any) => {
  const _component_ion_spinner = _resolveComponent("ion-spinner")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(ModalOne, {
      title: _unref(t)('components.ticket_detail_item.edit_ticket'),
      "is-open": isModalOpen.value
    }, {
      content: _withCtx(() => [
        _createElementVNode("form", {
          id: "changePasswordForm",
          "validation-schema": _unref(schema),
          onSubmit: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(onSubmit) && _unref(onSubmit)(...args)))
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", null, [
              _createVNode(_unref(IonInput), {
                type: "text",
                hidden: "hidden",
                name: "eventTicketId",
                value: props.ticketId
              }, null, 8, ["value"])
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(TextInput, {
                id: "input-field",
                class: "mr-2",
                "wrapper-class": "flex flex-wrap justify-left item-center mb-3 border border-solid focus-within:background-white-15",
                type: "text",
                name: "name",
                placeholder: _unref(t)('form.name'),
                value: props.name,
                onInputChanged: _unref(onInputChange)
              }, null, 8, ["placeholder", "value", "onInputChanged"]),
              _createVNode(_unref(IonButton), {
                class: "go-back-button",
                onClick: closeModalAndGo
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonIcon), {
                    icon: require('@/statics/svg/people-add.svg'),
                    class: "w-[50px] h-[50px] cursor-pointer"
                  }, null, 8, ["icon"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(TextInput, {
                id: "input-field",
                "wrapper-class": "flex flex-wrap justify-left item-center mb-3 border border-solid focus-within:background-white-15",
                type: "text",
                name: "email",
                placeholder: _unref(t)('form.email'),
                value: props.email,
                onInputChanged: _unref(onInputChange)
              }, null, 8, ["placeholder", "value", "onInputChanged"])
            ]),
            _createVNode(_unref(IonButton), {
              disabled: !_unref(isFormValid),
              expand: "full",
              shape: "round",
              type: "submit"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('components.ticket_detail_item.edit_ticket')), 1)
              ]),
              _: 1
            }, 8, ["disabled"])
          ])
        ], 40, _hoisted_1)
      ]),
      actions: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_unref(IonIcon), {
              class: "text-[38px] text-black cursor-pointer",
              icon: _unref(closeOutline),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (showHideModal(false)))
            }, null, 8, ["icon"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["title", "is-open"]),
    _createElementVNode("div", _hoisted_7, [
      (!__props.ticket.event?.delayed_delivery_datetime || (__props.ticket.event?.delayed_delivery_datetime && __props.eventTickets && __props.eventTickets[0].qr_code))
        ? (_openBlock(), _createBlock(_unref(IonButton), {
            key: 0,
            class: "hover:bg-white hover:rounded-full",
            size: "large",
            shape: "round",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (startDownloadingTicket(__props.ticket.event, __props.ticket, __props.idx)))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_8, [
                (downloadingTicket.value.ticketIndex === __props.idx && downloadingTicket.value.isDownloading)
                  ? (_openBlock(), _createBlock(_component_ion_spinner, {
                      key: 0,
                      name: "dots",
                      class: "text-dark-blue mr-2"
                    }))
                  : (_openBlock(), _createBlock(_unref(IonIcon), {
                      key: 1,
                      icon: _unref(downloadOutline),
                      class: "text-dark-blue mr-2"
                    }, null, 8, ["icon"])),
                _createElementVNode("span", _hoisted_9, _toDisplayString(downloadingTicket.value.ticketIndex === __props.idx && downloadingTicket.value.isDownloading ? _unref(t)('events.tickets.tickets_detail.downloading') : _unref(t)('events.tickets.tickets_detail.download')), 1)
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      id: `ticket-${props.ticketId}`,
      class: "bg-white rounded-md p-6 w-[300px]"
    }, [
      _createElementVNode("div", _hoisted_11, [
        (hideQrCode.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "relative cursor-pointer",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (showQrCode()))
            }, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(t)('components.ticket_detail_item.press_to_show')), 1)
              ]),
              (!props.valueOnly)
                ? (_openBlock(), _createBlock(QrcodeVue, {
                    key: 0,
                    value: props.qrCode,
                    level: 'M',
                    size: qrCodeSize.value,
                    background: "#E0E0E0",
                    class: "cursor-pointer transition-all duration-300",
                    onClick: cycleQrCodeSize
                  }, null, 8, ["value", "size"]))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_14, [
              (!props.valueOnly)
                ? (_openBlock(), _createBlock(QrcodeVue, {
                    key: 0,
                    value: props.qrCode,
                    level: 'M',
                    size: qrCodeSize.value,
                    background: "#E0E0E0",
                    class: "cursor-pointer transition-all duration-300",
                    onClick: cycleQrCodeSize
                  }, null, 8, ["value", "size"]))
                : (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: "flex flex-col items-center text-l break-all text-dark-blue/70 cursor-pointer transition-all duration-300",
                    onClick: cycleQrCodeSize
                  }, [
                    _createElementVNode("span", null, [
                      _createElementVNode("b", null, _toDisplayString(_unref(t)('components.ticket_detail_item.code')), 1)
                    ]),
                    _createTextVNode(" " + _toDisplayString(props.qrCode), 1)
                  ]))
            ]))
      ]),
      (props.walletLinked)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_unref(IonIcon), {
                icon: _unref(linkOutline),
                class: "mr-2 text-white"
              }, null, 8, ["icon"]),
              _createTextVNode(" " + _toDisplayString(_unref(t)('components.ticket_detail_item.your_wallet_linked')), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          (true || (!props.ticketDisabledEdit && props.eventAllowEditTickets))
            ? (_openBlock(), _createBlock(_unref(IonButton), {
                key: 0,
                onClick: _cache[4] || (_cache[4] = ($event: any) => (showHideModal(true))),
                class: "w-[24px] h-[24px] ion-no-margin ion-no-padding inline-flex items-center",
                fill: "clear"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonIcon), {
                    icon: _unref(createOutline),
                    class: "text-dark-blue"
                  }, null, 8, ["icon"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_19, _toDisplayString(props.name), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_20, [
        (isQueueTicket.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              _createElementVNode("span", _hoisted_22, _toDisplayString(_unref(t)('queue.queue_ticket')), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", {
            style: _normalizeStyle(`background-color: ${props.ticketTypeColor !== undefined && _ctx.$props.ticketTypeColor != '' ? props.ticketTypeColor : '#000000'}`),
            class: "flex min-h-[37px] px-4 py-1 items-center justify-center rounded-md max-w-full"
          }, [
            _createElementVNode("span", _hoisted_24, _toDisplayString(isQueueTicket.value ? activityName.value : props.ticketTypeName), 1)
          ], 4)
        ]),
        (isQueueTicket.value && queueTypeDisplay.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
              _createElementVNode("span", _hoisted_26, _toDisplayString(queueTypeDisplay.value), 1)
            ]))
          : _createCommentVNode("", true),
        (isQueueTicket.value && displayTicketType.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
              _createElementVNode("span", _hoisted_28, _toDisplayString(displayTicketType.value), 1)
            ]))
          : _createCommentVNode("", true),
        (isQueueTicket.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
              (formattedTimeslot.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(formattedTimeslot.value), 1))
                : (isUnbooked.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(_unref(t)('queue.unbooked')), 1))
                  : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (isUnbooked.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
              _createVNode(_unref(IonButton), {
                class: "hover:bg-white hover:rounded-full",
                size: "default",
                shape: "round",
                onClick: handleBookNow
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_33, _toDisplayString(_unref(t)('queue.book_now')), 1)
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("div", _hoisted_35, _toDisplayString(props.eventName), 1)
        ]),
        (!isQueueTicket.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
              (!props.ticket.event?.hide_date_time)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", _hoisted_36, [
                      _createElementVNode("div", _hoisted_37, [
                        _createElementVNode("span", _hoisted_38, _toDisplayString(_unref(t)('components.ticket_detail_item.date')), 1),
                        _createElementVNode("span", _hoisted_39, _toDisplayString(_unref(DateTime).fromFormat(props.eventDate, 'yyyy-MM-dd HH:mm:ss').toFormat('EEEE dd MMM, yyyy')), 1)
                      ]),
                      _createVNode(_unref(IonIcon), {
                        icon: _unref(calendarClearOutline),
                        class: "text-dark-blue"
                      }, null, 8, ["icon"])
                    ]),
                    _createElementVNode("div", _hoisted_40, [
                      _createElementVNode("div", _hoisted_41, [
                        _createElementVNode("span", _hoisted_42, _toDisplayString(_unref(t)('components.ticket_detail_item.time')), 1),
                        _createElementVNode("span", _hoisted_43, _toDisplayString(_unref(DateTime).fromFormat(props.eventDate, 'yyyy-MM-dd HH:mm:ss').toFormat('HH:mm a')), 1)
                      ]),
                      _createVNode(_unref(IonIcon), {
                        icon: _unref(timeOutline),
                        class: "text-dark-blue"
                      }, null, 8, ["icon"])
                    ]),
                    (props.ticketTypeDescription)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                          _createElementVNode("div", _hoisted_45, [
                            _createElementVNode("span", _hoisted_46, _toDisplayString(_unref(t)('components.ticket_detail_item.description')), 1),
                            _createElementVNode("span", _hoisted_47, _toDisplayString(props.ticketTypeDescription), 1)
                          ]),
                          _createVNode(_unref(IonIcon), {
                            icon: _unref(informationCircleOutline),
                            class: "text-dark-blue"
                          }, null, 8, ["icon"])
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true),
              (props.venue)
                ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                    _createElementVNode("div", _hoisted_49, [
                      _createElementVNode("span", _hoisted_50, _toDisplayString(_unref(t)('components.ticket_detail_item.venue')), 1),
                      _createElementVNode("span", _hoisted_51, _toDisplayString(props.venue), 1)
                    ]),
                    _createVNode(_unref(IonIcon), {
                      icon: _unref(locationOutline),
                      class: "text-dark-blue"
                    }, null, 8, ["icon"])
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true)
      ])
    ], 8, _hoisted_10)
  ]))
}
}

})